import { useTranslation } from 'react-i18next'

import { SystemUser } from '../../types'
import RoleIcon from '../../assets/icons/role-icon.svg'
import MailIcon from '../../assets/icons/mail-icon.svg'
import AccountIcon from '../../assets/icons/account-icon.svg'
import DocumentIcon from '../../assets/icons/document-icon.svg'
import SystemUserDataTableRow from './system-user-data-table-row'

const SystemUserDataTable = ({ systemUserData, selectedPocketName }: { systemUserData: Partial<SystemUser>; selectedPocketName: string }) => {
  const { t } = useTranslation(['system-users-management'])

  return (
    <div className="system-user-data-table-container">
      <SystemUserDataTableRow
        icon={
          <img
            src={AccountIcon}
            alt="account-icon"
          />
        }
        rowName={t('updateSystemUserModal.systemUserDataTable.rowTitles.firstName')}
        rowValue={systemUserData.firstName ?? ''}
      />
      <SystemUserDataTableRow
        icon={
          <img
            src={AccountIcon}
            alt="account-icon"
          />
        }
        rowName={t('updateSystemUserModal.systemUserDataTable.rowTitles.lastName')}
        rowValue={systemUserData.lastName ?? ''}
      />
      <SystemUserDataTableRow
        icon={
          <img
            src={MailIcon}
            alt="mail-icon"
          />
        }
        rowName={t('updateSystemUserModal.systemUserDataTable.rowTitles.email')}
        rowValue={systemUserData.username ?? ''}
      />
      <SystemUserDataTableRow
        icon={
          <img
            src={RoleIcon}
            alt="role-icon"
          />
        }
        rowName={t('updateSystemUserModal.systemUserDataTable.rowTitles.userRole')}
        rowValue={
          systemUserData?.role === 'admin'
            ? t('userRoles.administrator')
            : systemUserData?.role === 'admin-client' || systemUserData?.role === 'super-admin-client'
            ? t('userRoles.administrator')
            : systemUserData?.role === 'admin-client-builder'
            ? t('userRoles.builder')
            : t('userRoles.builder')
        }
      />
      {selectedPocketName && systemUserData.belongsTo !== 'holdings' && (
        <SystemUserDataTableRow
          icon={
            <img
              src={RoleIcon}
              alt="role-icon"
            />
          }
          rowName={t('updateSystemUserModal.systemUserDataTable.rowTitles.assignedTo')}
          rowValue={selectedPocketName.toUpperCase()}
        />
      )}
      {systemUserData?.description && (
        <SystemUserDataTableRow
          icon={
            <img
              src={DocumentIcon}
              alt="document-icon"
            />
          }
          rowName={t('updateSystemUserModal.systemUserDataTable.rowTitles.description')}
          rowValue={systemUserData?.description}
        />
      )}
    </div>
  )
}

export default SystemUserDataTable
